import React from 'react'
import { Avatar } from 'antd'

import { apiUrl } from '../../config'
import utils from './../../utils'
import { subStringAvatar } from './CellText'

export const AvatarHasName = props => {
  const { imgId, name, justifyContent, position, icon, size } = props

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: justifyContent || 'flex-start',
        alignItems: 'center',
      }}>
      <Avatar
        size={size || 28}
        style={{ backgroundColor: '#2C65AC', fontSize: 12 }}
        src={imgId && `${apiUrl}/api/v1/images/${imgId}`}>
        {icon ? (
          <div
            className="mt-[7px]"
            style={{
              transform: 'translate(-50%, 0%)',
              position: 'absolute',
            }}>
            {icon}
          </div>
        ) : (
          subStringAvatar(name)
        )}
      </Avatar>
      <div
        style={{
          fontWeight: 600,
          marginLeft: 5,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}>
        <span style={{ whiteSpace: 'nowrap', lineHeight: 1 }}>{utils.getNameInCapitalize(name)}</span>
        {position && (
          <i style={{ fontWeight: 400, margin: '0 8px' }}>({position})</i>
        )}
      </div>
    </div>
  )
}